<template>
    <div class="alert-ccb-feature">
        <modal height="auto" width="515px" name="ccb-new-feature-modal" :clickToClose="false">
            <div class="informative-modal flex flex-col" style="padding: 20px;">
                <div class="header">
                    New Feature! Cross Campaign Blocking
                </div>
                <div class="body" style="color: rgba(0, 0, 0, 0.9);">
                    One of our most popular requests is now available. By clicking the Enable button below, the Cross Campaign Blocking will be applied to all your Google Ads accounts protected by PPC Shield. If enabled, the detected IP will be blocked across all of your campaigns. By clicking Blocking settings in the left-side menu, you can change the settings at any time.
                </div>
                <div class="footer flex justify-content-between space-x-2">
                    <div>
                        <button class="btn hidden" style="height: 25px;" @click="temporarilyHide"></button>
                    </div>
                    <div>
                        <button class="btn gray mr-2" @click="onNotNow">NOT NOW</button>
                        <button class="btn btn-primary" style="color: white" @click="onEnable">ENABLE</button>
                    </div>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
    export default {
        data(){
            return {
                canShowAlert: true,
            }
        },
        methods: {
            temporarilyHide(){
                this.$modal.hide('ccb-new-feature-modal');
            },
            onEnable() {
                this.$modal.hide('ccb-new-feature-modal');

                axios.post('/notification/ccbFeatureEnable')
                    .then(info => {

                    })
                    .catch(err => console.log('err', err));
            },
            onNotNow() {
                this.$modal.hide('ccb-new-feature-modal');

                axios.post('/notification/ccbFeatureNotNow')
                    .then(info => {

                    })
                    .catch(err => console.log('err', err));
            },
            showAlert(){
                this.$modal.show('ccb-new-feature-modal');
                this.canShowAlert = false;
            }
        },
        mounted() {
            const _this = this;
            $('body').click(function (event) {
                if (_this.canShowAlert) {
                    event.stopPropagation();
                    event.preventDefault();
                    _this.showAlert();
                    _this.canShowAlert = false;
                }
            });
        }
    }
</script>
